import { DfmFileOrderByEnum } from "@admin_api/models/dfm-file-order-by-enum";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-dfm-files-table-cell-content",
    templateUrl: "./dfm-files-table-cell-content.component.html",
    styleUrls: ["./dfm-files-table-cell-content.component.less"],
    standalone: false
})
export class DfmFilesTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;
    @Output() download = new EventEmitter<number>();
    @Output() reprocess = new EventEmitter<number>();

    DfmFileOrderByEnum = DfmFileOrderByEnum;

    constructor() {}

    onClickReprocess() {
        this.reprocess.emit(this.element.id);
    }

    onClickDownload() {
        this.download.emit(this.element.id);
    }

}
